import ConnectedSelector from './ConnectedSelector';

export default ConnectedSelector;
